import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./styles/index.less";
import VueClipboard from "vue-clipboard2";
import store from "./store";
import "lib-flexible/flexible.js";
import "@/utils/directive.js";
import {Lazyload} from "vant";
import "@/utils/tracking/build/tracking-min.js";
import "@/utils/tracking/build/data/face-min.js";

// import * as Sentry from "@sentry/vue";
// import {Integrations} from "@sentry/tracing";

// Sentry.init({
//     Vue,
//     dsn: "https://2b4ae2b7e098c403f703ebf8f9be9be0@o4507214422409216.ingest.us.sentry.io/4507252209352704",
//     logErrors: true,
//     integrations: [
//         Sentry.browserTracingIntegration(),
//         Sentry.replayIntegration({
//             unmask: ['.unmask-me'],
//             networkDetailAllowUrls: [window.location.origin],
//             networkRequestHeaders: ['Cache-Control', 'X-Custom-Header'],
//             networkResponseHeaders: ['Referrer-Policy', 'X-Custom-Header'],
//             maskAllText: false,
//         }),
//         new Integrations.BrowserTracing({
//             routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//             tracingOrigins: ["localhost", /^\//],
//         }),
//         Sentry.Integrations.Breadcrumbs({
//             xhr: true
//         })
//     ],
//     // 设置 beforeSend 回调函数
//     beforeSend: (event, hint) => {
//         const error = hint.originalException;
//         // 过滤特定的错误
//         if (event.exception) {
//             // 检查是否为 CSS 文件加载失败的错误
//             if (error && error.target && error.target.nodeName === 'LINK' && error.target.rel === 'stylesheet') {
//                 // 返回 null 将阻止错误事件被发送到 Sentry
//                 return null;
//             }
//             // 或者检查错误信息是否包含相关的关键词
//             if (error.message && error.message.includes('Failed to load stylesheet')) {
//                 return null;
//             }
//             // 检查是否为 JS 文件加载失败的错误
//             if (error && error.target && error.target.nodeName === 'SCRIPT') {
//                 // 返回 null 将阻止错误事件被发送到 Sentry
//                 return null;
//             }
//             // 或者检查错误信息是否包含相关的关键词
//             if (error.message && error.message.includes('Failed to load script')) {
//                 return null;
//             }
//             // 根据错误消息过滤
//             if (error.message && error.message.includes('IgnoreThisError')) {
//                 return null;
//             }
//             // 根据错误类型过滤
//             if (error instanceof TypeError) {
//                 return null;
//             }
//             // 检查错误信息是否包含未捕获的 Promise 错误特征
//             if (error && error.message && error.message.includes('Uncaught (in promise)')) {
//                 return null;
//             }
//             // 根据自定义条件过滤
//             if (error.message && (error.message.includes('NetworkError') || error.message.includes('SomeOtherError'))) {
//                 return null;
//             }
//         }
//         return event;
//     },
//     tracesSampleRate: 1.0,
//     tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
// });

import tools from "@/utils/interaction";

Vue.prototype.$tools = tools

import {saveAppsFlyer} from "@/services/common";

import VueSignaturePad from "vue-signature-pad";

Vue.use(VueSignaturePad);

Vue.prototype.$saveAppsFlyer = saveAppsFlyer;
if (process.env.NODE_ENV == "development") {
    Vue.config.devtools = true;
    const vConsole = require("@/utils/vconsole");
    Vue.use(vConsole);
} else {
    // console.log = () => {};
}
Vue.use(Lazyload);
Vue.use(VueClipboard);
Vue.config.productionTip = false;

var vue = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");

export default vue;
